import { constants } from '../stores/FiltersStore';

export default {
  filters: {
    setGuests(guests) {
      this.dispatch(constants.SET_GUESTS, guests);
    },
    setLocation({ city, country }) {
      this.dispatch(constants.SET_LOCATION, { city, country });
    },
    setSearchMode(mode) {
      this.dispatch(constants.SET_SEARCH_MODE, mode);
    },
    setFilters(filters) {
      this.dispatch(constants.SET_FILTERS, { filters });
    },
    flushFilters() {
      this.dispatch(constants.FLUSH_FILTERS);
    },
    setDates({ selectedFrom, selectedTo }) {
      this.dispatch(constants.SET_DATES, { selectedFrom, selectedTo });
    },
    setAvailabilityFilter({ availability }) {
      this.dispatch(constants.SET_AVAILABILITY_FILTER, { availability });
    },
    setFilterLang(lang) {
      this.dispatch(constants.SET_LANG, lang);
    },
  },
};
